module.exports = __webpack_public_path__ + "img/img-fed97bee.33496431.png";